
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 44 44"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Raggruppa 854","transform":"translate(-5234 -11091)"}},[_c('path',{attrs:{"data-name":"Icon awesome-instagram","d":"M5250.528 11113.345a5.808 5.808 0 101.7-4.116 5.817 5.817 0 00-1.7 4.116zm9.6 0a3.782 3.782 0 11-3.782-3.782 3.782 3.782 0 013.782 3.782zm-9.838-7.412a1.354 1.354 0 11-.96.4 1.357 1.357 0 01.96-.4zm1.377-3.853a6.715 6.715 0 00-4.754 1.833 6.759 6.759 0 00-1.833 4.754c-.107 1.873-.107 7.488 0 9.361a6.749 6.749 0 001.827 4.754 6.737 6.737 0 004.755 1.833c1.873.106 7.488.106 9.362 0a6.715 6.715 0 004.754-1.833 6.768 6.768 0 001.832-4.754c.106-1.873.106-7.488 0-9.362a6.715 6.715 0 00-1.833-4.754 6.759 6.759 0 00-4.754-1.833c-1.873-.106-7.483-.106-9.356 0zm11.366 2.415a3.829 3.829 0 012.157 2.157c.592 1.494.456 5.038.456 6.688s.132 5.2-.456 6.688a3.829 3.829 0 01-2.157 2.167c-1.493.587-5.033.451-6.688.451s-5.2.132-6.688-.456a3.829 3.829 0 01-2.157-2.157c-.592-1.494-.456-5.038-.456-6.688s-.132-5.2.456-6.688a3.829 3.829 0 012.157-2.162c1.494-.592 5.038-.456 6.688-.456s5.2-.132 6.688.456z"}}),_c('circle',{attrs:{"data-name":"Ellipse 298","cx":"22","cy":"22","r":"22","transform":"translate(5234 11091)","fill":"none"}})])])
          )
        }
      }
    